// frontend/src/site/components/SiteListingGrid.jsx
import React, { useMemo } from 'react';
import SiteListingCard from './SiteListingCard';
import { useSite } from '../SiteContext';

import {
  gridGapClasses,
  mutedTextClasses,
  buttonClasses,
} from '../theme/siteStyles';

const cx = (...c) => c.filter(Boolean).join(' ');

const keyOf = (p, idx) => {
  const id = String(p?.objectID ?? p?.imovelId ?? p?.id ?? p?.refCodigo ?? '');
  return id || `noid-${idx}-${p?.referencia || ''}`;
};

export default function SiteListingGrid({
  items = [],
  onLoadMore = () => {},
  loading = false,
  exhausted = false,
  whatsappUrl,
  cols = { base: 1, sm: 2, lg: 3, xl: 4 },
}) {
  const { ownerWhatsUrl, theme } = useSite() || {};
  const waFinal = whatsappUrl || ownerWhatsUrl || '';

  const list = useMemo(() => {
    const seen = new Set();
    return (Array.isArray(items) ? items : []).filter(Boolean).filter((p) => {
      const k = String(
        p?.objectID ?? p?.imovelId ?? p?.id ?? p?.refCodigo ?? ''
      );
      if (!k) return true;
      if (seen.has(k)) return false;
      seen.add(k);
      return true;
    });
  }, [items]);

  if (!loading && list.length === 0) {
    return (
      <div
        className={cx('text-center py-12', mutedTextClasses())}
        aria-live="polite"
      >
        Nenhum imóvel encontrado.
      </div>
    );
  }

  const colClasses = [
    `grid-cols-${cols.base || 1}`,
    cols.sm ? `sm:grid-cols-${cols.sm}` : '',
    cols.lg ? `lg:grid-cols-${cols.lg}` : '',
    cols.xl ? `xl:grid-cols-${cols.xl}` : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <>
      <div
        className={cx('grid', gridGapClasses(theme), colClasses)}
        aria-busy={loading ? 'true' : 'false'}
        aria-live="polite"
      >
        {list.map((p, idx) => (
          <SiteListingCard key={keyOf(p, idx)} p={p} whatsappUrl={waFinal} />
        ))}
      </div>

      {!exhausted && (
        <div className="flex justify-center py-10">
          <button
            type="button"
            onClick={() => !loading && onLoadMore()}
            disabled={loading}
            className={cx(
              buttonClasses(theme, 'secondary'),
              // tamanho um pouco mais “call-to-action”
              'px-7',
              loading && 'opacity-60 cursor-not-allowed'
            )}
            aria-label={
              loading ? 'Carregando mais imóveis' : 'Carregar mais imóveis'
            }
          >
            {loading ? 'Carregando…' : 'Carregar mais'}
          </button>
        </div>
      )}
    </>
  );
}
